import { z } from "zod/v4";
const TelephoneNumberSchema = z
    .string()
    .regex(/^.*-.*-.*$/, {
    message: "-(ハイフン)を含めて入力してください。",
})
    .regex(/^\d{2,5}-\d{1,4}-\d{3,4}$/)
    .brand();
export const TelephoneNumber = {
    schema: TelephoneNumberSchema,
};
//# sourceMappingURL=telephone-number.js.map